// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1z8mD","consentsList":"PatientConsents_consentsList__27py2","consentsListEmpty":"PatientConsents_consentsListEmpty__1mff-"};